import {FILTERS_ARGS} from "../training-const"
import { getMultipleQueryValue } from "@/util"

export default class QuestionsFilterDTO {
  constructor(queries = {}) {
    this.category = getMultipleQueryValue(queries[FILTERS_ARGS.CATEGORY])
    this.layout = getMultipleQueryValue(queries[FILTERS_ARGS.LAYOUT])
    this.search = queries[FILTERS_ARGS.SEARCH]
    this.type = queries[FILTERS_ARGS.TYPE]
    this.license_type = queries[FILTERS_ARGS.LICENSE_TYPE]
  }
}